import React from 'react';

import classNames from 'classnames';

import { SessionStatus } from '@/lib/types/session-status';

export interface StatusSelectProps {
  status: SessionStatus;
  onChange: (status: StatusSelectProps['status']) => void;
  options?: {
    value: SessionStatus[];
    label: string;
    className: string;
    disabled?: boolean;
  }[];
  disabled?: boolean;
}

const statusClasses = {
  [SessionStatus.Booked]: 'bg-success-10 text-black border-success-40 w-28',
  [SessionStatus.Completed]: 'bg-success-30 text-black border-success-40 w-30',
  [SessionStatus.Canceled]: 'bg-danger-30 text-black border-danger-40 w-30',
  [SessionStatus.New]: 'bg-primary-10 text-black border-primary-20 w-28',
  [SessionStatus.Skipped]: 'bg-primary-10 text-black border-primary-20 w-28',
};

const defaultOptions = [
  {
    value: [SessionStatus.Booked],
    label: 'Booked',
    className: 'bg-success text-black',
    disabled: true,
  },
  {
    value: [SessionStatus.Completed],
    label: 'Completed',
    className: 'bg-success text-black',
  },
  {
    value: [SessionStatus.Skipped],
    label: 'Skipped',
    className: 'bg-danger text-black',
  },
  {
    value: [SessionStatus.Canceled],
    label: 'Canceled',
    className: 'bg-danger text-black',
    disabled: true,
  },
];

export const StatusSelect = ({
  status,
  onChange,
  options = defaultOptions,
  disabled,
}: StatusSelectProps) => {
  const handleMouseDown = (e: React.MouseEvent<HTMLSelectElement>) => {
    if (disabled) {
      e.preventDefault();
    }
  };

  return (
    <div className="relative inline-block w-fit">
      <select
        value={status}
        onChange={(e) => onChange(e.target.value as StatusSelectProps['status'])}
        onMouseDown={handleMouseDown}
        className={classNames(
          'py-1 px-2 pr-8 rounded-[8px_8px_8px_8px] border text-md font-medium cursor-pointer outline-none font-inter appearance-none border-neutral-30',
          statusClasses[status as SessionStatus],
          { '!pr-2 text-center': disabled },
        )}
      >
        {options.map((option) => (
          <option
            key={option.label}
            value={option.value}
            className={option.className}
            disabled={option.disabled}
          >
            {option.label}
          </option>
        ))}
      </select>
      {!disabled && (
        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
          <svg
            className="w-4 h-4 text-neutral-70"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      )}
    </div>
  );
};
